<style>
</style>
<template>
    <span>
    <Drawer title="学习币充值记录" :closable="false" placement="right" v-model="amountDrawer" width="50%">
        <Row style="padding-top: 5px">
            <Table :loading="loading" border :columns="userColumns" :data="userData" ref="userTable"></Table>
        </Row>
        <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
        </Row>
    </Drawer>
    </span>
</template>
<script>
    import {amountList} from "@/api/bus";

    export default {
        name: "amountRecordDrawer",
        props: {
            id: ""
        },
        data() {
            return {
                modalVisible: false,
                amountDrawer: false,
                modalTitle: '积分记录',
                loading: true,
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    userId: ""
                },
                permData: [],
                userColumns: [
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "学习币",
                        key: "amount"
                    },
                    {
                        title: "描述",
                        key: "title",
                        sortable: true
                    },
                    {
                        title: "获取时间",
                        key: "createTime",
                        sortable: true
                    }
                ],
                userData: [],
                total: 0
            }
        },
        methods: {
            //加载数据
            showDrawer(params){
                this.amountDrawer = true;
                if (params.id) {
                    this.searchForm.userId = params.id;
                    this.getData();
                }
            },
            getData() {
                this.loading = true;
                amountList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.userData = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getData();
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getData();
                this.clearSelectAll();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            cancelSubmit() {
                this.modalVisible = false;
            },
        },
        mounted() {

        }
    }
</script>